(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cutfound-floating-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cutfound-floating-product')) {
    customElements.define('cutfound-floating-product', class extends HTMLElement {
      connectedCallback() {
        this.image = this.querySelector('img');
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.images = JSON.parse(this.querySelector('[data-images]').textContent);
        this.section = document.getElementById('MainProduct-' + this.dataset.section);
        this.inProduct = true;
        this.ready = false;
        this.requestNumber = 0;
        this.onChange = (event) => {
          if (event.target.matches('input[name="id"]')) this.update(event.target.value);
        };
        this.section?.addEventListener('change', this.onChange);
        this.onHistory = () => this.update(new URL(location.href).searchParams.get('variant') || this.dataset.selected);
        window.addEventListener('popstate', this.onHistory);
        this.observer = new IntersectionObserver((entries) => {
          this.inProduct = entries[0].isIntersecting;
          this.hidden = !this.inProduct || !this.ready;
        });
        if (this.section) this.observer.observe(this.section);
        this.update(this.dataset.selected);
      }
      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onChange);
        window.removeEventListener('popstate', this.onHistory);
        this.observer?.disconnect();
        this.requestNumber++;
      }
      update(id) {
        const variant = this.variants.find((item) => String(item.id) === String(id));
        const source = variant && this.images.find(item => String(item.variant) === String(id));
        this.dataset.automatic = String(source?.automatic || false);
        const request = ++this.requestNumber;
        this.dataset.variant = String(id);
        this.ready = false;
        this.hidden = true;
        if (!source?.url) return;
        const pending = new Image();
        pending.onload = () => {
          if (request !== this.requestNumber || !this.isConnected) return;
          this.image.src = source.url;
          this.ready = true;
          this.hidden = !this.inProduct;
        };
        pending.onerror = () => {
          if (request === this.requestNumber) this.hidden = true;
        };
        pending.src = source.url;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cutfound-style-it-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-style-look')) {
    customElements.define('cf-style-look', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.form = this.querySelector('[data-look-form]');
        if (!this.form) return;
        this.events = new AbortController();
        this.rows = Array.from(this.querySelectorAll('[data-look-product]'));
        this.button = this.querySelector('[data-look-add]');
        this.total = this.querySelector('[data-look-total]');
        this.hint = this.querySelector('[data-look-hint]');
        this.status = this.querySelector('[data-look-status]');
        this.pending = false;
        this.form.addEventListener('change', () => {
          this.status.textContent = '';
          this.updateSelection();
        }, {signal: this.events.signal});
        this.form.addEventListener('submit', event => this.addLook(event), {signal: this.events.signal});
        this.updateSelection();
      }

      disconnectedCallback() {
        this.events?.abort();
      }

      updateSelection() {
        let amount = 0;
        let included = 0;
        let missing = 0;
        this.rows.forEach(row => {
          const include = row.querySelector('[data-look-include]');
          const picker = row.querySelector('[data-look-variant]');
          const quantity = row.querySelector('[data-look-quantity]');
          const selected = include.checked && !include.disabled;
          if (!picker) return;
          picker.disabled = !selected;
          picker.required = selected;
          quantity.disabled = !selected;
          const option = picker.selectedOptions[0];
          if (option?.dataset.money) row.querySelector('[data-look-price]').textContent = option.dataset.money;
          if (!selected) return;
          included += 1;
          amount += Number(option?.dataset.price ?? row.dataset.startPrice);
          if (!picker.value || option?.disabled) missing += 1;
        });
        this.total.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {
          style: 'currency', currency: this.dataset.currency || 'USD', currencyDisplay: 'narrowSymbol'
        }).format(amount / 100);
        this.button.disabled = this.pending || included === 0 || missing > 0;
        this.button.textContent = this.pending ? this.dataset.addingLabel : this.dataset.addLabel;
        this.hint.hidden = missing === 0;
      }

      async addLook(event) {
        event.preventDefault();
        if (this.pending || !this.form.reportValidity()) return;
        const items = this.rows.filter(row => {
          const include = row.querySelector('[data-look-include]');
          return include.checked && !include.disabled;
        }).map(row => ({id: Number(row.querySelector('[data-look-variant]').value), quantity: 1}));
        if (!items.length || items.some(item => !item.id)) return;
        this.pending = true;
        this.status.textContent = '';
        this.updateSelection();
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.errorLabel);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.pending = false;
          this.updateSelection();
          this.status.textContent = error.message || this.dataset.errorLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
